import { render, staticRenderFns } from "./restricciones-colaboraciones-editar.vue?vue&type=template&id=2f9d182a&"
import script from "./restricciones-colaboraciones-editar.vue?vue&type=script&lang=js&"
export * from "./restricciones-colaboraciones-editar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports